import { render, staticRenderFns } from "./safety-mode.vue?vue&type=template&id=6471ad1c"
import script from "./safety-mode.vue?vue&type=script&lang=js"
export * from "./safety-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports